export default __webpack_public_path__ + "assets/images/v-icon4-61723277.svg";